import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AuthService } from '../core/auth.service';
import { ItemService } from '../services/item.service';

@Component({
  selector: 'app-brand-audit-request',
  templateUrl: './brand-audit-request.component.html',
  styleUrls: ['./brand-audit-request.component.css']
})
export class BrandAuditRequestComponent implements OnInit {

   
  requestForm: FormGroup;
  title: string;
  questionType_selected: any;
  types_arr: any;

  public singleDate: any;


  constructor(private itemService: ItemService,private router: Router, private _fb: FormBuilder, private afs: AngularFirestore, private authService: AuthService) { }

 

  ngOnInit() {

    let parameters:any = { section_name: 'Brand Audit', page_name: 'Request'}
      this.itemService.logEvent('onPageView', parameters);

    // if (this.authService.currentUser !== 'Admin') {
    //   this.router.navigate(['/home'])
    // }

    var d = new Date();
    var n = 'request_' + d.getTime();

    this.requestForm = this._fb.group({
      'request_id': n,
      'company_name': ['', Validators.required],
      'department': ['', Validators.required],
      'applicant_name': ['', Validators.required],
      'cell_number': ['', Validators.required],
      'email': ['', Validators.required],
      'brandToProbe': ['', Validators.required],
      'competition': ['', Validators.required],
      'period': [[''], Validators.required],
      'additional_req': ['', Validators.required],
      
    });
  }

  onSubmit() {
    var d = new Date();
    var n = 'request_' + d.getTime();

    if (this.requestForm.valid) {

       const client_data = this.requestForm.value;
       

       client_data.request_id = n;
       client_data.user_id = this.authService.currentUserId;
       client_data.client_name = this.authService.loggedInUserClient;
       client_data.createdDate = d;

    var setDoc = this.afs.collection('brandAudit').doc(client_data.request_id).set(client_data);
   alert("Request has been saved");

   let parameters:any = { 
    section_name: 'Brand Audit',
    page_name: 'Request',
    request_id: client_data.request_id,
  }
  this.itemService.logEvent('OnBrandAuditFormSubmission', parameters);

  this.router.navigateByUrl('/home');
 ///this.router.navigateByUrl('/calendar/list-post/' + this.doc_id);
 
  }
 
  }
 
 
}


// WEBPACK FOOTER //
// ./src/app/brand-audit-request/brand-audit-request.component.ts